import React, { useEffect, useState } from 'react'
import { Button, Divider, Flex, Popover, Typography } from 'antd'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import TopBar from '../TopBar'
import { database } from '../../../utils/firebase'
import { SlOptionsVertical } from 'react-icons/sl'
import { useSelector } from 'react-redux'
import Messages from './Messages'
import ChatFooter from './ChatFooter'
import { searchClient } from '../../../utils/algolia'
import { generateSoapNotesDocument, mergePdfs, zapierSetSOAPFormDetails } from '../APIS'
import moment from 'moment'
import qs from 'qs'
import { path } from '../../../utils/const'
import axios from 'axios'

const { Text } = Typography

const StartChat = () => {
  const { chatID } = useParams()
  const [labTracking, setLabTracking] = useState(null)
  const [patient, setPatient] = useState(null)
  const me = useSelector((state) => state.app.me)
  const [messages, setMessages] = useState(null)
  const navigate = useNavigate()
  const [endChatLoading, setEndChatLoading] = useState(false)
  const location = useLocation()
  const query = new URLSearchParams(location.search)
  const issues = 'Report issues'

  const navigateTo = () => {
    navigate(path.profileview)
  }

  const navigateToEmail = (decline) => {

    query.set('reason', decline)
    const emailPath = path.sendmail
    const paramsString = query.toString()
    const url = new URL(window.location.href)
    url.search = paramsString
    navigate(emailPath + url.search)
  }

  const fetchLabDetails = async () => {
    const snapshot = await database.ref(`labTracking/${chatID}`).once('value')
    const response = snapshot.val()
    console.log('response', response)
    setLabTracking(response)

    if (response && me.id && response.patientID && response.conversationID) {
      database.ref(`/labTracking/${chatID}`).once('value', (snapshot) => {
        const resp = snapshot.val()
        setLabTracking(resp)

      })
    }
  }

  const navigateToSoapNotes = (chatID) => {
    navigate(`/writesoapnotes/${chatID}`)
  }
  const handleViewDetailsClick = () => {
    navigate(`/labtracking/${chatID}`)
  }

  useEffect(() => {
    fetchLabDetails()
  }, [])

  useEffect(() => {
    if (labTracking?.patientID) {
      database.ref(`users/${labTracking?.patientID}`).once('value', (snapshot) => {
        const response = snapshot.val()
        console.log('Patient', response)
        setPatient(response)
      })
    }
  }, [labTracking?.patientID])

  useEffect(() => {
    if (labTracking?.conversationID) {
      database.ref(`conversations/${labTracking?.conversationID}`).on('value', (snapshot) => {
        console.log('response', snapshot.val())
        setMessages(snapshot.val())
      })
    }
  }, [labTracking?.conversationID])

  const storeCloseChatIndex = async (conversationID) => {
    try {
      const indexStore = searchClient.initIndex(
        process.env.REACT_APP_ALGOLIA_CONVERSATIONS_NODE_INDEX_NAME,
      )
      const archiveSnap = await database
        .ref(`archiveConversations/${conversationID}`)
        .once('value')
      const archiveData = archiveSnap?.exists() ? archiveSnap.toJSON() : {}
      const convoSnap = await database
        .ref(`/conversations/${conversationID}`)
        .once('value')
      let convos = ''
      const convoJSON = convoSnap?.exists() ? convoSnap.toJSON() : {}
      const convoValues = Object.values(convoJSON)
      convoValues.forEach((convoInstance) => {
        if (convoInstance.type === 'text') {
          convos = `${convos} ${convoInstance.content}`
        }
      })
      const doctorSnap = await database
        .ref(`/doctors/${archiveData.doctorID}`)
        .once('value')
      const doctorData = doctorSnap?.exists() ? doctorSnap.toJSON() : {}
      const patientSnap = await database
        .ref(`/users/${archiveData.patientID}`)
        .once('value')
      const patientData = patientSnap?.exists() ? patientSnap.toJSON() : {}
      let tags = ''
      if (archiveData.tagsList) {
        const tagslist = _.map(archiveData.tagsList, (val, uid) => {
          return { ...val, uid }
        })
        tagslist.forEach((tag) => {
          if (tag.name) {
            tags = `${tags}, ${tag.name}`
          }
        })
      }
      const chatCount = Object.keys(patientData.history_conversations || {})
      archiveData.tags = tags
      archiveData.objectID = archiveSnap.key
      archiveData.conversations = convos
      archiveData.conversationID = archiveSnap.key
      archiveData.patientEmail = patientData.email
      archiveData.city = patientData.city
      archiveData.country = patientData.country
      archiveData.platform = patientData.platform
      archiveData.DOB = patientData.DOB
      archiveData.gender = patientData.gender
      archiveData.symptoms = archiveData.symptoms || patientData.symptoms
      archiveData.gmtOffset = patientData.gmtOffset
      archiveData.buildNumber = patientData.buildNumber
      archiveData.convoCount = chatCount.length
      archiveData.doctorName = archiveData.doctorName || doctorData.doctorName
      archiveData.doctorProfileImg = doctorData.profileImageURL
      archiveData.doctorEmail = doctorData.email
      archiveData.user_id = patientData.user_id
      archiveData.healthInsuranceCardBack =
        patientData.healthInsuranceCardBack || null
      archiveData.healthInsuranceCardFront =
        patientData.healthInsuranceCardFront || null
      archiveData.healthInsuranceCardNumber =
        patientData.healthInsuranceCardNumber || null
      console.log('')
      await indexStore.saveObject(archiveData, {
        autoGenerateObjectIDIfNotExist: true,
      })
    } catch (e) {
      console.error('Error storing data to Algolia:', e)
    }
  }

  const sendCloseChatNotification = (
    notificationToken,
    doctorName,
    chatId,
    doctorID,
  ) => {
    axios({
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      url: `${process.env.REACT_APP_FIREBASE_CLOUD_FUNCTION_URL}/closeChatInapp?notificationToken=${notificationToken}&doctorName=${doctorName}&chatId=${chatId}&doctorID=${doctorID}`,
      mode: 'cors',
    })
      .then((data) => {
      })
      .catch((e) => {
      })
    axios({
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      url: `${process.env.REACT_APP_FIREBASE_CLOUD_FUNCTION_URL}/closeChat?notificationToken=${notificationToken}&doctorName=${doctorName}&chatId=${chatId}&doctorID=${doctorID}`,
      mode: 'cors',
    })
      .then((data) => {
      })
      .catch((e) => {
      })
  }
  const closeUserChat = async (chatID) => {
    try {
      const convoSnap = await database
        .ref(`/openconversations/${chatID}`)
        .once('value')
      const currentConvo = convoSnap.exists() ? convoSnap.toJSON() : {}
      const patientID = currentConvo?.patientID || null
      const owner = currentConvo?.owner || null
      const userSnap = await database.ref(`/users/${patientID}`).once('value')
      const userJSON = userSnap.exists() ? userSnap.toJSON() : {}
      const { complete_address, sources = {}, notificationToken } = userJSON
      if (convoSnap.exists()) {
        const archiveData = {
          ...currentConvo,
          start_timestamp: currentConvo?.timestamp || null,
          status: false,
          queued: false,
          timestamp: Date.now(),
          diagnosisValue: currentConvo?.assessment || null,
          assessment: currentConvo?.assessment || null,
          followUpData: null,
          medications: null,
          commentAdded: currentConvo?.plan || null,
          complete_address: complete_address || 'NA',
          owner,
        }
        const closeData = {
          ...currentConvo,
          activeTimestamp:
            currentConvo.activeTimestamp || currentConvo.timestamp || null,
          start_timestamp: currentConvo.timestamp || null,
          status: false,
          queued: false,
          timestamp: Date.now(),
          location: chatID,
          diagnosisValue: currentConvo?.assessment || null,
          commentAdded: currentConvo?.plan || null,
        }
        if (currentConvo?.prescriptionspdf) {
          closeData.billableChat = true
        }
        const sourceKeys = Object.keys(sources)
        const sourceValues = Object.values(sources)
        let sourceTimestamp = null
        let source = null
        if (sourceKeys.length > 0) {
          sourceTimestamp = sourceValues[0]
          source = sourceKeys[0]
          sourceValues.forEach((sourceTime, index) => {
            if (sourceTime > sourceTimestamp) {
              sourceTimestamp = sourceTime
              source = sourceKeys[index]
            }
          })
        }
        archiveData.source = source
        closeData.source = source
        const updates = {}
        updates[`/archiveConversations/${chatID}`] = archiveData
        updates[`/users/${patientID}/conversations`] = null
        updates[`/openconversations/${chatID}`] = null
        updates[`/users/${patientID}/history_conversations/${chatID}`] = closeData

        console.log('updates', updates)
        await database.ref().update(updates)
        await storeCloseChatIndex(chatID)
        if (
          notificationToken &&
          currentConvo?.doctorName &&
          currentConvo?.doctorID &&
          chatID
        ) {
          await sendCloseChatNotification(
            notificationToken,
            currentConvo?.doctorName,
            chatID,
            currentConvo?.doctorID,
          )
        }
      } else {
        window.alert('Chat already closed!')
      }
    } catch (e) {
      console.error('closeUserChat error ', e)
      window.alert('Error closing chat, please try again later!')
    }
  }

  const handleEndChat = async () => {
    setEndChatLoading(true)

    const currentConversationID = labTracking?.conversationID
    if (currentConversationID) {
      const soapNotes = await database.ref(`/openconversations/${currentConversationID}/soapNotesData`).once('value').then((s) => s.val())
      if (!soapNotes?.assessment || !soapNotes?.plan || !soapNotes?.symptoms || !soapNotes?.findings) {
        window.alert(' Please complete soap notes')
        return
      }
      const confirmed = window.confirm('Are you sure you want to close this chat?')
      if (!confirmed) {
        setEndChatLoading(false)
        return
      }

      try {
        if (currentConversationID) {
          const payload = {
            findings: soapNotes?.findings || '',
            assessment: soapNotes?.assessment || '',
            issue: soapNotes?.symptoms || '',
            plan: soapNotes?.plan || '',
            patientName: patient?.name || '',
            patientDOB: patient?.DOB || '',
            patientGender: patient?.gender || '',
            patientPhone: patient?.phone_number,
            encounterDate: moment().format('MM/DD/YYYY'),
            patientHealthCardNumber: patient?.healthInsuranceCardNumber || '',
            doctorName: me?.doctorName || '',
            doctorLicense: me?.license || '',
            country: patient?.country,
          }

          const soapNoteDoc = await generateSoapNotesDocument(payload)
          console.log('soapNoteDOc', soapNoteDoc)

          //soapNoteDoc.finalLink response.finalPdf check network where the calls are made

          if (labTracking?.results?.length > 0) {
            const merge_payload = {
              pdfLink: soapNoteDoc.finalLink,
              attachmentLinks: labTracking?.results,
              documentName: `${me?.name || ''} - ${
                patient?.name || ''
              } - ${moment().format('MM/DD/YYYY')}`,
            }
            const response = await mergePdfs(merge_payload)
            console.log('merge pdf', response)
          }


          const zapierSetSOAPFormDetailsPayload = {
            doctorName: me?.doctorName,
            chatID: currentConversationID,
            assessment: soapNotes?.assessment,
            diagnosisValue: soapNotes?.assessment, // I'm not sure if this will work???
            findings: soapNotes?.findings,
            symptoms: soapNotes?.symptoms,
            plan: soapNotes?.plan,
            billingcodes: me?.billingCode || null,
            billingunits: me?.billingUnits || null,
            prescriptionspdf: null,
            soapnotespdf: soapNoteDoc.finalLink || null,
            prescription: null,
            doctorid: me?.id || null,
            diagnosticcode: '799', /// Hardcoded consult if it has to change
            healthcard: patient?.healthInsuranceCardNumber,
            sex: patient?.gender,
            phone: patient.phone_number,
            name: patient?.name,
            birthday: moment(patient?.DOB, 'MMMM DD YYYY').format(
              'MM/DD/YYYY'),
            patientID: labTracking?.patientID,
          }

          await zapierSetSOAPFormDetails(
            qs.stringify(zapierSetSOAPFormDetailsPayload),
          )
          //return

          const updates = {}
          const timestampKey = new Date().getTime() //Date.now();
          updates[`labTracking/${chatID}/conversationID`] = null
          updates[`labTracking/${chatID}/oldSessions/${timestampKey}`] = currentConversationID // incase they dont want it
          await closeUserChat(labTracking?.conversationID)
          await database.ref().update(updates)

          console.log('Chat closed successfully')
          navigate('/labrequistionpage')
        } else {
          console.log('No active conversation to close')
        }
      } catch (e) {
        console.error('Error while closing the chat:', e)
        alert.error('Something went wrong while closing the chat.')
      } finally {
        setEndChatLoading(false)
      }
    } else {
      setEndChatLoading(false)
    }
  }

  const content = (
    <Flex vertical gap="small" style={{ width: '100px' }}>
      <Button type="text" size="small" onClick={handleEndChat} loading={endChatLoading}>
        End consultation
      </Button>


      <Button onClick={(event) => navigateToEmail(issues)} type="text" size="small"> Contact support </Button>
    </Flex>
  )

  return (
    <div>
      <TopBar title="Chat" />
      <Flex justify="space-between" gap="small" style={{ padding: '9px' }}>
        <Text strong>
          {labTracking?.patientName}
        </Text>
        <Popover content={content} placement="leftBottom" trigger="click">
          <SlOptionsVertical />
        </Popover>
      </Flex>
      <Flex gap="small" style={{ padding: '0 2px 4px 9px' }}>
        <Text strong>
          D.O.B- {patient?.DOB}
        </Text>
      </Flex>
      <Flex gap="middle" justify="space-around">
        <Button style={{ borderColor: '#872873', color: '#872873', borderWidth: '2px' }}
                onClick={() => handleViewDetailsClick(chatID)}>View Consultation</Button>
        <Button style={{ borderColor: '#872873', color: '#872873', borderWidth: '2px' }}
                onClick={() => navigateToSoapNotes(chatID)}> Add Soap Notes</Button>
      </Flex>
      <Divider style={{ margin: '5px', padding: '3px' }} />
      <Messages messages={messages} />
      <ChatFooter conversationID={labTracking?.conversationID} patientID={labTracking?.patientID} />
    </div>
  )
}

export default StartChat
